import { Controller } from "@hotwired/stimulus";
import { navigateWithConfirm } from "./customization/lib";
// Connects to data-controller="site-builder--redirects"
export default class extends Controller {
  static values = {
    redirect: String
  }

  connect() {
    const isPersisted = !!document.body.dataset.siteBuilderSite

    if (this.redirectValue && window.self !== window.top) {
      if (isPersisted) {
        navigateWithConfirm(this.redirectValue)
      } else {
        window.open(this.redirectValue)
      }
    }
  }
}
